export const toBiProps = (props, pick)=>props.noBi ? {
        noBi: props.noBi
    } : {
        bi: pick(props.bi)
    };
